/* eslint-disable */
import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ButtonProps } from "./Button";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { motion } from "framer-motion";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import { resetUserfilter } from "../../../viewer/presenters/UserFilterActions";
import { resetSearchResult } from "../../../viewer/search/SearchActions";
import clsx from "clsx";
import styles from "./NavButton.module.css";

interface NavButtonProps extends ButtonProps {
  path: string;
}

function NavButton({ children, path, ...otherProps }: NavButtonProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { user } = useSelector((state: AppState) => ({
    user: state.user.userInfo,
  }));
  const { header } = useSelector((state: AppState) => ({
    header: state.header,
  }));

  let fromPageNum = 0;
  let toPageNum = 0;
  const menuList = [
    "/homepage",
    "/presenter",
    "/channel",
    "/project",
    "/videos",
    "/search",
  ];
  for (let i = 0; i < menuList.length; i++) {
    if (header.to === menuList[i]) {
      fromPageNum = i;
    }
    if (path === menuList[i]) {
      toPageNum = i;
    }
  }

  const isActive =
    path === "/presenter" && user
      ? pathname.startsWith(path) && !pathname.includes(`${user.id}`)
      : path === "/videos" && pathname.startsWith("/video/")
      ? true
      : pathname.startsWith(path)
      ? true
      : path === "/channels" && pathname.startsWith("/channel/");

  const handleClick = useCallback(
    (e: any) => {
      if (
        !isActive ||
        pathname.startsWith("/video/") ||
        pathname.startsWith("/channel/")
      ) {
        let direction = "";
        if (fromPageNum > toPageNum) {
          direction = "left";
        } else if (fromPageNum < toPageNum) {
          direction = "right";
        }

        dispatch(changeMenu(header.to, path, direction));
        dispatch(
          resetfilter({
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: [],
          })
        );
        dispatch(resetUserfilter({ id: -1, skill: [], tag: [] }));
        dispatch(resetSearchResult());
        navigate(path);

        if (otherProps.onClick) {
          otherProps.onClick(e);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [dispatch, history, otherProps, path, fromPageNum, toPageNum, header.to]
  );

  const classes = clsx({
    [styles.buttonActive]: isActive,
    [styles.buttonWhite]: !isActive,
  });

  return (
    <motion.div
      whileHover={{
        scale:
          !isActive ||
          pathname.startsWith("/video/") ||
          pathname.startsWith("/channel/")
            ? 1.1
            : 1,
      }}
    >
      <button
        className={classes}
        onClick={handleClick}
        {...otherProps}
        style={{
          cursor:
            pathname.startsWith("/video/") || pathname.startsWith("/channel/")
              ? "pointer"
              : "",
        }}
      >
        <div className={styles.content}>
          {otherProps.icon && (
            <div className={styles.icon}>{otherProps.icon}</div>
          )}

          {children && (
            <div className={isActive ? styles.labelActive : styles.label}>
              {children}
            </div>
          )}
        </div>
      </button>
    </motion.div>
  );
}

export default NavButton;
